import { ApolloClient, OperationVariables } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';
import { DocumentNode } from 'graphql';
import { unauthorizedInterceptor } from '@/resources/auth/auth';

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: '/graphql',
  credentials: 'same-origin'
});

// Cache implementation
const cache = new InMemoryCache({
  addTypename: false
});

const errorLink = onError(({ operation }) => {
  const { response } = operation.getContext();
  unauthorizedInterceptor(response);
});

const link = errorLink.concat(httpLink);

// Create the apollo client
export const apolloClient = new ApolloClient({
  link,
  cache
});

export async function executeQuery<T>(query: DocumentNode, variables?: OperationVariables): Promise<T> {
  const response = await apolloClient.query<T>({ query, variables, fetchPolicy: 'no-cache' });
  return response.data;
}

export async function executeMutation<T>(
  mutation: DocumentNode,
  variables?: OperationVariables
): Promise<T | null | undefined> {
  const response = await apolloClient.mutate<T>({ mutation, variables, fetchPolicy: 'no-cache' });
  return response.data;
}
